import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import css from './CategoriesCard.module.css';

// Category tile for the "Our ethical marketplace sells everything" section.
// The tile links to the search page, already filtered by this category, so a
// visitor can browse straight from the landing page. `category` is the option
// key of the 'category' listing field, e.g. 'mother-and-baby'.
// A tile without a `category` still renders, just as a plain, non-clickable
// tile — that was how every tile looked before Jira P25028-115.
const CategoriesCard = props => {
  const { icon, labelId, category } = props;

  const content = (
    <>
      <span className={css.iconTile} aria-hidden="true">
        {icon}
      </span>
      <span className={css.cardLabel}>
        <FormattedMessage id={labelId} />
      </span>
    </>
  );

  if (!category) {
    return <div className={css.card}>{content}</div>;
  }

  return (
    <NamedLink
      className={css.cardLink}
      name="SearchPage"
      to={{ search: `?pub_category=${encodeURIComponent(category)}` }}
    >
      {content}
    </NamedLink>
  );
};

export default CategoriesCard;
